import React from 'react';
import { AuthWrapper } from '../../../components/AuthWrapper/AuthWrapper';
import { RegisterGoogleForm } from 'src/pages/RegisterPage/RegisterGooglePage/RegisterGoogleForm';

const Title = () => (
  <div>
    <p className={'uppercase text-[1.375rem] text-black font-bold'}>Tell us more about you</p>
  </div>
);

const RegisterGooglePage = () => {
  return (
    <AuthWrapper title={<Title />}>
      <div
        className={
          'flex flex-col w-[450px] md:w-[534px] rounded-[15px] border border-white bg-[#ffffff66] py-[25px] px-[46px]'
        }
      >
        <RegisterGoogleForm />
      </div>
    </AuthWrapper>
  );
};

export default RegisterGooglePage;
